module.exports = __webpack_public_path__ + "img/arrow-down.f563fc25.svg";